import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchRepatriationsTransactionsExecute from '../../api/RepatriationsTransactionsExecuteAPI';
import { REPATRIATIONS_TRANSACTIONS_EXECUTE_REQUEST } from '../actions/types/RepatriationsTransactionsExecuteActionsTypes';
import { postRepatriationsTransactionsExecuteSuccessActionCreator, postRepatriationsTransactionsExecuteFailureActionCreator } from '../actions/RepatriationsTransactionsExecuteActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doRepatriationsTransactionsExecuteWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchRepatriationsTransactionsExecute, action.payload);
    yield put(postRepatriationsTransactionsExecuteSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.repatriations.transaction.execute.success'),
    }));
  } catch (error) {
    yield put(postRepatriationsTransactionsExecuteFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doRepatriationsTransactionsExecuteWatcher() {
  yield takeLatest(REPATRIATIONS_TRANSACTIONS_EXECUTE_REQUEST, doRepatriationsTransactionsExecuteWorker);
}

export default doRepatriationsTransactionsExecuteWatcher;
